import { useMemo, useState } from "react";
import { Info } from "lucide-react";
import ExplicacaoTermoModal from "./ExplicacaoTermoModal";
import glossario from "../db_public/glossario.json";

/* Caderno Cívico Contemporâneo: a fonte é uma nota editorial discreta, nunca um elemento de destaque. */

function escaparRegExp(texto) {
  return texto.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}

export default function TextoComGlossario({ children, className }) {
  const [termoSelecionado, setTermoSelecionado] = useState(null);
  const textoCompleto = String(children ?? "");
  const referenciaEncontrada = textoCompleto.match(/\s*(\(págs?\.\s*[^)]*\*\))\s*$/u);
  const referencia = referenciaEncontrada?.[1] ?? null;
  const texto = referenciaEncontrada ? textoCompleto.slice(0, referenciaEncontrada.index).trimEnd() : textoCompleto;

  const { padrao, definicoesPorTermo } = useMemo(() => {
    const termos = [...glossario]
      .sort((a, b) => b.length - a.length)
      .map((item) => item.termo);
    const definicoes = new Map(termos.map((termo) => [termo.toLocaleLowerCase("pt-BR"), glossario.find((item) => item.termo === termo)]));
    const alternativas = termos.map(escaparRegExp).join("|");

    return {
      padrao: alternativas ? new RegExp(`((?<![\\p{L}\\p{N}])(?:${alternativas})(?![\\p{L}\\p{N}]))`, "giu") : null,
      definicoesPorTermo: definicoes,
    };
  }, []);

  const partes = padrao ? texto.split(padrao) : [texto];

  return (
    <>
      <span className={className}>
        {partes.map((parte, indice) => {
          const definicao = definicoesPorTermo.get(parte.toLocaleLowerCase("pt-BR"));

          if (!definicao) return <span key={`${parte}-${indice}`}>{parte}</span>;

          return (
            <button
              type="button"
              className="teste-cego-glossario__termo focus-ring"
              key={`${definicao.id}-${indice}`}
              onClick={() => setTermoSelecionado(definicao)}
              aria-label={`Ver explicação sobre ${definicao.termo}`}
            >
              {parte}
              <span className="teste-cego-glossario__marcador" aria-hidden="true">
                <Info size={12} strokeWidth={2.5} />
              </span>
            </button>
          );
        })}
      </span>
      {referencia && <span className="teste-cego__referencia-pagina" aria-label={`Referência de fonte: ${referencia}`}>{referencia}</span>}
      {termoSelecionado && <ExplicacaoTermoModal termo={termoSelecionado} aoFechar={() => setTermoSelecionado(null)} />}
    </>
  );
}
